export const AGENT = {
  AUTHORIZE: 'AUTHORIZE',
  AGENT_ASSESSMENTS: 'AGENT_ASSESSMENTS',
  AGENT: 'AGENT',
};
